<template>
    <div>
        <div class="Underlay">
            <div class="Underlay-content">

                <div class="parking-information">
                    <span>{{ park.parkingLot.name }}</span>
                
                    <br>

                    <span style="margin-top: 20px; display: block;">车位：{{ parkingName }}</span>
               
                   

                </div>
            </div>




            <div class="money-information-type" v-if="status != 0">
                <div class="information">
                    <div class="type">
                        <div class="type-one">停车开始时间</div>
                        <div>{{ park.rsParkRec.startTime || "无" }}</div>
                    </div>
                    <div class="type">
                        <div class="type-one">车牌号</div>
                        <div>{{ park.rsParkRec.carNumber || '无' }}</div>
                    </div>
                </div>
            </div>

            <div class="money-information" v-else>
                <div class="Prepaid-amount">
                    <div>预付金额</div>
                    <div>￥{{ park.cashPledge || '无' }}</div>
                </div>
                <div class="Underline"></div>

                <div class="explain">
                    <p>预付说明：驶离时请再次扫码，预付金多退少补。</p>
                    <p>若有问题，请联系现场管理员或致电客服</p>
                </div>
                <div class="explain-type">
               
                    <!-- <div class="type-one">车牌号</div>
                    <div>{{ carNumberTemp || '无' }}</div> -->
                </div>
                
            </div>

           
        </div>





        <!-- <el-drawer :visible.sync="show" class="el-drawer__drawer" direction="btt" :show-close="false" :withHeader="false">

            <div class="car-group">

                <div class="car-box">
                    <span :class="`car-input ${chooseClass(index)}`" @click="handleCar(index)"
                        v-for="(item, index) in value" :key="index">{{ item }}</span>

                </div>

                <div class="car-row" v-for="(item, index) in keys" :key="index">
                    <span @click="handleKey(item2)" class="car-cell" v-for="(item2, index2) in item" :key="index2">
                        {{ item2 }}
                    </span>
                </div>
            </div>
        </el-drawer> -->
        
        <div class="plate" v-if="PlateType">
                <plate-input ref="plateInput1"></plate-input>
            </div>




        <el-button class="parkbtn" type="primary" @click="ParkOff" v-if="status===1">车辆离场</el-button>
        <el-button class="parkbtn" type="primary"  v-if="status == 4">请等待管理员确认</el-button>
        <el-button class="parkbtn" type="primary" @click="submit" v-if="status===0">开始停车</el-button>

    </div>
</template>

<script>

import plateInput from '../../components/plateInput'
import { getManagerOffParkInfo, getUserInfoByOpenId, getApplyParkIn, getApplyParkOff, getUnionOrder } from "@/api/coupon/admin";
export default {
    name: "index",
    data() {
        return {
            show: false,
            parkingName: "",
            lotId: "",
            park: "",
            userOpenId: "",
            parkId: "",
            userId: "",
            platetypeId: "",
            carNumber: undefined,
            status: "",
            id: "",
            destade: false,
            PlateType:true,
            type: "",



        }
    },

    components: {
        plateInput
    },
    computed: {
        chooseClass() {
            return function (index) {
                if (this.show) {
                    if (index == this.index) {
                        return 'choose-class'
                    }
                    else {
                        return ''
                    }
                } else {
                    return ''
                }

            }
        },
        keys() {
            let flag = this.index
            if (flag == 0) {
                return this.keyJC
            }
            else if (flag == 6) {
                return this.lastKey
            }
            else {
                return this.normalkey
            }
        }
    },
    watch: {
        value() {
            let newStr = this.value.join()
            this.$emit('change', newStr)
        }
    },

    created() {



        this.userOpenId = localStorage.getItem("userOpenId")
  
        this.lotId = this.$encryptUtil.decrypt(
            this.$route.query.lotId
        );
        this.parkingName = this.$encryptUtil.decrypt(
            this.$route.query.parkingName
        );
        // let oderId = true
        // if (oderId) {
        //     this.$router.push({ name: 'ParkingDetails',query:{lotId:this.lotId,parkingName:this.parkingName} })
        // }
        this.ParkInfo()
    },
    methods: {
        getPlateNumber(data) {
            console.log('传值', data);
            this.carNumber = data
        },
        ParkOff() {
            let params = {
                id: this.rsParkRecId,
            }
            getApplyParkOff(params).then(res => {
                console.log(res, '123456789');
                if (res.code == 200) {
                    console.log(res.data.type,'res.data.type');
                    this.type = res.data.type
                    if (res.data.type != 0) {
                      
                        this.$router.push({ name: 'ParkingDetails', query: { lotId: this.lotId, parkingName: this.parkingName, rsParkRecId: this.rsParkRecId } })
                    } else {
                        // this.$weui.alert(res.msg)
                        this.$weui.alert("离场成功，请联系管理员确认")
                        this.ParkInfo()
                        this.destade = true
                    }
                }


            })
        },
        OpenId() {
            getUserInfoByOpenId(this.userOpenId).then(res => {
                console.log(res, 'res');

                this.platetypeId = res.data.platetypeId
                this.userId = res.data.id
                this.carNumber = res.data.carNumber.toString()
                this.carNumberTemp = res.data.carNumber.join('')

            })
        },
        ParkInfo() {
            let params = {
                parkingName: this.parkingName,
                lotId: this.lotId,
            }
            getManagerOffParkInfo(params).then(res => {
                console.log(res, '123456879');
              
            
               
                

                this.status = res.data.parkingInfo.status
                console.log(this.status,'this.status');
             
                if (this.status!==0) {
                   
                    this.PlateType=false
                   
                }else{
                    this.PlateType=true
                }
              
                this.park = res.data
                this.parkId = this.park.parkingInfo.id
                if (this.park.rsParkRec) {
                    this.rsParkRecId = res.data.rsParkRec.id
                    this.park.rsParkRec.startTime = this.newDate(this.park.rsParkRec.startTime)
                }




                this.OpenId()

            })
        },
  
    


        newDate(time) {
            var date = new Date(time)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? '0' + m : m
            var d = date.getDate()
            d = d < 10 ? '0' + d : d
            var h = date.getHours()
            h = h < 10 ? '0' + h : h
            var minute = date.getMinutes()
            minute = minute < 10 ? '0' + minute : minute
            var s = date.getSeconds()
            s = s < 10 ? '0' + s : s
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
        },
        submit() {


            // if (!this.$refs.plateInput1.getPlateNumber()) {
            //     this.$weui.alert('请输入正确的车牌号')
            //     return
            // }

            let params = {
                parkId: this.parkId,
                userId: this.userId,
                platetypeId: this.platetypeId,
                carNumber: this.$refs.plateInput1.getPlateNumber(),
            }
          
            if (params.carNumber!=undefined) {
                console.log(params.carNumber,'车牌');
                if (params.carNumber.length < 7) {
                delete params.carNumber
            }
            }
            

            getApplyParkIn(params).then(res => {

                if (res.code == 200) {
                   
                    console.log(this.checkBrowser.id,'this.checkBrowser.id');
                   
                    
                    let data = {
                        orderSn: res.msg,
                        parkinglotId: this.lotId,
                        payType: this.checkBrowser.id,
                        openId: this.userOpenId
                    }
                    getUnionOrder(data).then(req => {

                        if (req.code == 200) {
                            this.$roadsidePay(req)
                         
                        }
                    })
                } else {
                    this.carNumber = null

                    this.value = ['', '', '', '', '', '', '']
                    this.index = 0
                }
            })

        },




    }
}
</script>
<style >
.Underlay {
    position: relative;
    width: 100%;
    height: 50vh;
    background-color: #6181E8;
    border-radius: 0 0 20% 20%;

}
.plate{
    margin: 55px 0 ;
}
.money-information {
    border-radius: 10px;

    width: 90%;
    /* height: 20vh; */
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #FFFFFF;
    position: absolute;
    left: 50%;
    top: 90%;
    transform: translate(-50%, -50%)
}

.money-information-type {
    border-radius: 10px;

    width: 90%;
    height: 20vh;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #FFFFFF;
    position: absolute;
    left: 50%;
    top: 90%;
    transform: translate(-50%, -50%)
}

.type {

    display: flex;
}

.type-one {
    width: 120px;
    height: 30px;
}

.information {
    margin: 20px;
    display: flex;
    flex-direction: column;
}

.explain {

    /* margin: 20px 0 0 0 ; */
    margin: auto;
    margin-top: 20px;
    width: 90%;
    color: #CF725B;

    background-color: #FEF5F6;
}

.Prepaid-amount {

    height: 40%;
    font-size: 25px;
    display: flex;
    justify-content: space-between;



}

.Prepaid-amount>div {
    margin: 10px 20px;
}

.Underline {
    width: 90%;
    height: 1px;
    background-color: #F1F1F1;
    margin: auto;
}

.parkbtn {

    width: 80%;
    position: absolute;
    left: 10%;

    bottom: 20px;
}

.explain-type {
    display: flex;
    margin: 20px;
}
.Underlay-content{
    margin-top: 20px;
}
</style>

<style scoped lang="stylus">
.Underlay-content{
    
    display: flex;
    flex-direction: column;
    justify-content: space-between;
 
    width: 80%;
    text-align: center;
    color: white;
 
    position: absolute;
    left:50%;
    top:20%;
    transform: translate(-50%, -50%)


    .parking-information{
        div{
            margin-bottom: 10px  ;
        }
    }



    
}

</style>
